import { render, staticRenderFns } from "./CopyrightDocs.vue?vue&type=template&id=5ce4c260&lang=pug&"
import script from "./CopyrightDocs.vue?vue&type=script&lang=js&"
export * from "./CopyrightDocs.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightDocs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports